import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ConvenioService } from '../../../../_services/convenio.service';
import { Convenio } from '../../../../_models/convenio';
import { ProductoConvenioFormaDesembolsoService } from '../../../../_services/producto-convenio-forma-desembolso.service';
import { ProductoConvenioFormaDesembolso } from '../../../../_models/producto-convenio-forma-desembolso';


@Component( {
  selector: 'app-producto-forma-desembolso-convenio',
  templateUrl: 'producto-forma-desembolso-convenio.component.html'
} )

export class ProductoFormaDesembolsoConvenioComponent implements OnInit {

  // I & O
  idProductoFormaDesembolso: string;
  @Output()
  alRegresar: EventEmitter<boolean> = new EventEmitter<boolean>();

  // Config
  convenios: Convenio[] = [];
  prodConvFds: ProductoConvenioFormaDesembolso[] = [];

  // Seleccionado
  convenioSelect: Convenio = null;
  prodConvFdSelect: ProductoConvenioFormaDesembolso = null;

  constructor(
    private convenioService: ConvenioService,
    private prodConvFdService: ProductoConvenioFormaDesembolsoService
  ) {
  }

  ngOnInit(): void {
    this.cargarConvenios();
    // this.cargarProductosConveniosFormasDesembolso(this.idProductoFormaDesembolso);
  }

  cargarConvenios() {
    this.convenioService.listado()
      .subscribe( convenio => {
        this.convenios = convenio.filter( x => x.indicadorHabilitado );
      } );
  }

  cargarProductosConveniosFormasDesembolso( id: string ) {
    this.idProductoFormaDesembolso = id;
    this.prodConvFdService.listadoPorProductoFormaDesembolso( id )
      .subscribe( res => {
        this.prodConvFds = res;
      } );
  }

  get conveniosSinProductoFd(): Convenio[] {
    return this.convenios.filter( x => this.prodConvFdsConConvenio.find( y => y.idConvenio === x.idConvenio ) === undefined );
  }

  get prodConvFdsConConvenio() {
    return this.prodConvFds.filter( x => x.indicadorHabilitado );
  }

  asignarConvenioToProductoFd( row?: Convenio ) {
    let list: ProductoConvenioFormaDesembolso[] = [];
    list = list.concat( this.agregarNuevoProdConvFd( row ? [ row ] : this.conveniosSinProductoFd ) );
    this.guardarprodConvFd( list );
  }

  desAsignarConvenioToProductoFd( row?: ProductoConvenioFormaDesembolso ) {
    const list: ProductoConvenioFormaDesembolso[] = [];
    if ( row ) {
      this.prodConvFds.forEach(item => {
        if ( item.idProductoConvenioFD === row.idProductoConvenioFD) {
          item.indicadorHabilitado = false;
          list.push(item);
          return;
        }
      });
    } else {
      this.prodConvFds.forEach(item => {
          item.indicadorHabilitado = false;
      });
    }
    this.guardarprodConvFd( row ? list : this.prodConvFds );
  }

  guardarprodConvFd( list: ProductoConvenioFormaDesembolso[] ) {
    // Guardar
    this.prodConvFdService.bulk( list )
      .subscribe( res => {
        this.prodConvFds = this.prodConvFds.concat(
          res.filter( x => this.prodConvFds.find( y => y.idProductoConvenioFD === x.idProductoConvenioFD ) === undefined )
        );
        list.forEach(x => {
          const model = this.prodConvFds.find(y => y.idConvenio === x.idConvenio);
          model.nombreConvenio = x.nombreConvenio;
          this.prodConvFds.splice(this.prodConvFds.findIndex(y => y.idConvenio === x.idConvenio), 1, model);
        });
      } );
  }

  /**
   * Agrega nuevos productosConveniosFormasDesembolsos dado un array de Convenios
   * Habilita los productosConveniosFormasDesembolsos que se encuentren deshabilitados pero ya pertenezcan a una lista de convenios
   * @param listaDeConvenios "convenios seleccionados"
   */
  agregarNuevoProdConvFd( listaDeConvenios: Convenio[] ) {
    const list: ProductoConvenioFormaDesembolso[] = [];
    listaDeConvenios.forEach( x => {
      let model = this.prodConvFds.find(y => y.idConvenio === x.idConvenio );
      if ( model ) {
        model.indicadorHabilitado = true;
      } else {
        model = {} as ProductoConvenioFormaDesembolso;
        model.idProductoFormaDesembolso = this.idProductoFormaDesembolso;
        model.idConvenio = x.idConvenio;
        model.nombreConvenio = x.nombre;
        model.indicadorHabilitado = true;
      }
      list.push( model );
    } );
    return list;
  }

  regresar() {
    this.alRegresar.emit(false);
  }
}
